import axios from 'axios';
import store from '@/store';
import { API_HOST } from './app-const';
import Vue from 'vue';
import i18n from '../i18n'

axios.defaults.baseURL = API_HOST;

/**
 * only send credentials for public bodhi
 */
function shouldSendCredentials(config) {
  const requestUrl = config.url || '';
  const baseUrl = config.baseURL || axios.defaults.baseURL || window.location.origin;

  try {
    const resolvedUrl = new URL(requestUrl, baseUrl);
    const configuredApiHost = new URL(API_HOST, window.location.origin);

    return resolvedUrl.origin === configuredApiHost.origin;
  } catch (e) {
    return false;
  }
}

// Handling token authentication pass-through
axios.interceptors.request.use(function (config) {
  config.withCredentials = shouldSendCredentials(config);

  if (!config.headers['Authorization']) {
    const user = store.state.user.user.data;
    if (user) {
      config.headers['Authorization'] = 'Token token=' + user.accessToken;
    }
  }
  return config;
});

// Handling 403 - forbidden response
axios.interceptors.response.use(undefined, function(error) {
  const statusCode = error && error.response ? error.response.status : null;

  if (statusCode === 401) {
    Vue.notify({
      group: 'store_notifications',
      type: 'error',
      text: i18n.t('acl.request.unauthorized')
    });
  } else if (statusCode === 403) {
    Vue.notify({
      group: 'store_notifications',
      type: 'error',
      text: i18n.t('acl.request.forbidden')
    });
  }

  return Promise.reject(error);
});